export const PublicationData = [

  {
    title: "Selling Source",
    icon: "",
    subMenu: [
      {
        title: "Add Selling Source",
        path: "createSellingSource",
        cName: "sub-nav",
        icon: "",
      },
      {
        title: "Edit Selling Source",
        path: "editSellingSource",
        cName: "sub-nav",
        icon: "",
      },

    ],
  },
  {
    title: "TDS",
    icon: "",
    subMenu: [
      {
        title: "Add TDS",
        path: "createTds",
        cName: "sub-nav",
        icon: "",
      },
      {
        title: "Edit TDS",
        path: "editTds",
        cName: "sub-nav",
        icon: "",
      },

    ],
  },
  {
    title: "Vendor",
    link: "vendor",
    icon: "",
  },
  {
    title: "DISPATCH ORDER",
    link: "dispatchOrders",
    icon: "",
  },
  {
    title: "Inevntory Management",
    icon: "",
    subMenu: [
      {
        title: "Stock In",
        path: "stockIn",
        cName: "sub-nav",
        icon: "",
      },
      {
        title: "Stock Out",
        icon: "",
        subMenu: [
          {
            title: "SHIFT STOCK",
            cName: "sub-nav",
            icon: "",
            path: "transferStock",
          },
          {
            title: "Sell Stock",
            cName: "sub-nav",
            icon: "",
            path: "sellStock",
          },
        ],
      },
      {
        title: "Order Return",
        path: "orderReturn",
        cName: "sub-nav",
        icon: "",
      },
      {
        title: "Damage In",
        path: "damageIn",
        cName: "sub-nav",
        icon: "",
      },
      {
        title: "Product History",
        path: "prodctHistory",
        cName: "sub-nav",
        icon: "",
      },
      {
        title: "Damage Stock",
        path: "damageStock",
        cName: "sub-nav",
        icon: "",
      },
    ],
  },
];
